/**
 * An on/off switch with its label beside it: one button that says it is a switch (`role="switch"`),
 * with its state in `aria-checked`. The label is inside the button, so it is the switch's name and a
 * click on it flips the switch too; Space and Enter flip it because it is a native button.
 *
 * The track and the knob each have a border, and the knob sits at one end or the other: forced
 * colours drop the fills, and the state still shows.
 */
export function Switch({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  /** Told the state the switch is to have: the opposite of `checked`. */
  onChange: (checked: boolean) => void;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className="focus-ring group inline-flex min-h-8 items-center gap-2 rounded-md text-sm font-medium text-ink-strong"
    >
      <span
        aria-hidden
        className="inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-ink-faint bg-card p-0.5 transition-colors group-aria-checked:justify-end group-aria-checked:border-action group-aria-checked:bg-action"
      >
        <span className="h-3.5 w-3.5 rounded-full border border-transparent bg-ink-faint group-aria-checked:bg-action-fg" />
      </span>
      {label}
    </button>
  );
}
